import styled from 'styled-components';

export const LegalDocumentStyle = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  background: #fcfbfb;
  border: 1px solid #e0dede;
  
  div.file-options-content {
    padding: 10px 10px 0;

    button {
      p {
        color: #364863;
      }

      &.btn-upload-legal-document-disabled {
        filter:  opacity(.5)
      }
    }

    p + p {
      margin-top: 3px;
    }

    p {
      span {
        &.date-warning {
          color: #F30;
          font-weight: bold;
        }
      }
    }
  }

  div.file-portrait {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FCFBFB;
    padding: 10px 5px;
    border-bottom: 1px solid #E0DEDE;

    p {
      color: #625C5C;
    }
  }
`;
